import { render, staticRenderFns } from "./PmReportTaskGnb.vue?vue&type=template&id=25fa1a36&"
import script from "./PmReportTaskGnb.vue?vue&type=script&lang=js&"
export * from "./PmReportTaskGnb.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports